import { useTour } from './useTour';

export function useWelcomeTour() {
  return useTour({
    tourId: 'welcome',
    steps: [
      {
        id: 'welcome',
        title: 'Welcome to Happy Alien',
        text: 'Your AI-powered eLearning command center. Let\'s take a quick look around so you can get the most out of your tools.',
        buttons: [
          { text: 'Skip tour', type: 'cancel', classes: 'shepherd-button-secondary' },
          { text: "Let's go", type: 'next', classes: 'shepherd-button-primary' },
        ],
      },
      {
        id: 'sidebar-nav',
        title: 'Navigation',
        text: 'Use the sidebar to move between sections. Everything you need is one click away.',
        attachTo: { element: '[data-tour="sidebar-nav"]', on: 'right' },
      },
      {
        id: 'nav-organization',
        title: 'Your organization',
        text: 'Manage your team, invite members, and keep everyone working from the same spark balance.',
        attachTo: { element: '[data-tour="nav-organization"]', on: 'right' },
      },
      {
        id: 'nav-usage',
        title: 'Track your usage',
        text: 'See exactly how your sparks are being spent across all products, with charts and breakdowns.',
        attachTo: { element: '[data-tour="nav-usage"]', on: 'right' },
      },
      {
        id: 'nav-subscription',
        title: 'Subscription plans',
        text: 'Choose a plan that fits your needs. Get monthly spark allowances, course creation tools, and more.',
        attachTo: { element: '[data-tour="nav-subscription"]', on: 'right' },
      },
      {
        id: 'quick-actions',
        title: 'Quick actions',
        text: 'Buy sparks, manage your subscription, or jump straight into your usage details from here.',
        attachTo: { element: '[data-tour="quick-actions"]', on: 'left' },
      },
    ],
  });
}
